module.exports = ".hidden{\n    display: none;\n}"